import React from "react";
import { Typography } from "@mui/material";

const FilePreview = ({ file }) => {
  if (!file) return null;

  const fileURL = URL.createObjectURL(file);

  const fileType = file.type;

  if (fileType.startsWith("video/")) {
    return <video src={fileURL} controls width="100%" />;
  } else if (fileType.startsWith("audio/")) {
    return <audio src={fileURL} controls />;
  } else if (fileType === "application/pdf") {
    return (
      <object data={fileURL} type="application/pdf" width="100%" height="500">
        <p>
          Your browser does not support PDFs.{" "}
          <a href={fileURL}>Download the PDF</a>
        </p>
      </object>
    );
  } else if (fileType.startsWith("image/")) {
    return <img src={fileURL} alt="" />;
  } else {
    return (
      <Typography>
        Unable to preview this file type. Please download it{" "}
        <a href={fileURL} download>
          here
        </a>
        .
      </Typography>
    );
  }
};

export default FilePreview;
